import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { Button, Spinner } from '@restworld/ui-ds-base';
import { useDownloadCv } from './hooks/use-download-cv';

export const DownloadCvButton = ({ url, name }: { url: string; name: string }) => {
  const { handleDownload, isLoading } = useDownloadCv();
  return (
    <Button variant="tertiary" className={'p-2.5 focus:ring-0'} onClick={() => handleDownload({ url, name })}>
      {!isLoading ? (
        <ArrowDownTrayIcon className="text-black w-5 h-5" />
      ) : (
        <Spinner color="primary" size="xs" className="h-5 w-5" />
      )}
    </Button>
  );
};
